import React from 'react';

import type { FiltersParams, SortParams } from 'common/types/SortAndFilter';
import { FilterDrawerProvider } from '../context/FilterDrawerContext';
import { FilterDrawerShell } from './FilterDrawerShell';

export interface CategoryFiltersDrawerProps extends SortParams, FiltersParams {
  hideArticlesCount?: boolean;
}

const CategoryFiltersDrawer = (props: CategoryFiltersDrawerProps) => {
  return (
    <FilterDrawerProvider {...props}>
      <FilterDrawerShell />
    </FilterDrawerProvider>
  );
};

export default CategoryFiltersDrawer;
